/**
 * Setting a canvas dimension drops its backing store and allocates a new one. A viewport that
 * shrinks and grows again (a side panel opening and closing) would re-allocate every layer on each
 * step, so a canvas keeps a backing store that still covers the viewport.
 *
 * A store more than twice the needed length is given back: the viewport got lastingly smaller.
 */
const MAX_SPARE_FACTOR = 2;

export function canvasBackingLength(current: number, needed: number): number {
  return current >= needed && current <= needed * MAX_SPARE_FACTOR
    ? current
    : needed;
}
